import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export default function CandidateSalary({ searchObject, onChange, t }) {
  return (
    <div>
      <div>
        <legend className="fontsize-legend">{t("Expected Salary")}</legend>
        <div className="row">
          <div className="col" style={{ paddingRight: "0px" }}>
            <input
              className="form-control fontsize-legend"
              type="number"
              value={searchObject.lowerBoundSalary || ""}
              name="lowerBoundSalary"
              onChange={onChange}
              min="0"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 10);
              }}
            />
            <div className="form-text">min.</div>
          </div>{" "}
          <div className="col" style={{ paddingLeft: "10px" }}>
            <input
              className="form-control fontsize-legend"
              type="number"
              value={searchObject.upperBoundSalary || ""}
              name="upperBoundSalary"
              onChange={onChange}
              min="0"
              onInput={(e) => {
                e.target.value = e.target.value.slice(0, 10);
              }}
            />
            <div className="form-text">max.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
